










import {Component, Emit, Vue} from "vue-property-decorator";

@Component({})
export default class RefreshButton extends Vue {
    @Emit()
    protected click() {
        //
    }
}
